import classNames from "classnames";
import { FC } from "react";
import styles from "./styles.module.scss";

type Props = {
  className?: string;
  isVibrate?: boolean;
  count: number;
  onClick?: VoidFunction;
};

const Hint: FC<Props> = ({ count, className, isVibrate, onClick }) => {
  return (
    <button
      className={classNames(
        styles.hint,
        {
          [styles.vibrate]: isVibrate,
        },
        className
      )}
      disabled={!onClick || count === 0}
      onClick={onClick}
      type="button"
    >
      <div className={styles.content}>
        {count}
        <div className={classNames("ui-icon-Key", styles.icon)} />
      </div>
    </button>
  );
};

export default Hint;
